/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AuditActionResponseSeverity } from './auditActionResponseSeverity';

export interface AuditActionResponse {
  action: string;
  category: string;
  description: string;
  severity: AuditActionResponseSeverity;
}
